var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOrbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    zoomAndPan: "magnify",
    viewBox: "0 0 338.25 338.249992",
    height: 125,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "a999790e2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 337.5 0 L 337.5 337.5 L 0 337.5 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a999790e2c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M 0 0 L 338.25 0 L 338.25 345.734375 L 0 345.734375 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M 0 0 L 337.5 0 L 337.5 337.5 L 0 337.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff1616",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.115369, 228.743155)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.042969 -71.21875 L 23.042969 -1.257812 C 23.042969 -0.699219 23.601562 0 24.578125 0 L 42.589844 0 C 43.570312 0 44.265625 -0.699219 44.265625 -1.257812 L 44.265625 -71.21875 Z M 1.535156 -92.582031 L 65.632812 -92.582031 C 66.609375 -92.582031 67.167969 -93.140625 67.167969 -93.839844 L 67.167969 -110.457031 C 67.167969 -111.015625 66.609375 -111.714844 65.632812 -111.714844 L 1.535156 -111.714844 C 0.699219 -111.714844 0 -111.015625 0 -110.457031 L 0 -93.839844 C 0 -93.140625 0.699219 -92.582031 1.535156 -92.582031 Z M 1.535156 -92.582031 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#1450a0",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.236635, 248.45811)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 85.183594 -91.1875 L 85.183594 -110.457031 C 85.183594 -111.015625 84.625 -111.714844 83.648438 -111.714844 L 65.492188 -111.714844 C 37.703125 -111.714844 0 -103.617188 0 -55.859375 C 0 -6.285156 38.121094 0 65.492188 0 L 83.648438 0 C 84.625 0 85.183594 -0.699219 85.183594 -1.257812 L 85.183594 -69.683594 L 42.3125 -69.683594 L 42.3125 -48.316406 L 63.816406 -48.316406 L 63.816406 -20.386719 C 39.519531 -19.132812 21.503906 -29.324219 21.503906 -55.859375 C 21.503906 -90.347656 50.273438 -91.746094 63.816406 -91.1875 Z M 85.183594 -91.1875 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrbit);
export default __webpack_public_path__ + "static/media/logoOrbit.4774717b3cd4086dbeaf555659db7e8e.svg";
export { ForwardRef as ReactComponent };